export default __webpack_public_path__ + "static/media/SWT0340.34I-18813_-14617_0.2d1007f6.jpg";